import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importation des fichiers de traduction
import fr from './locales/fr/translation.json';
import en from './locales/en/translation.json';
import de from './locales/de/translation.json';
import es from './locales/es/translation.json';
import it from './locales/it/translation.json';
import uk from './locales/uk/translation.json';
import hu from './locales/hu/translation.json';
import pt from './locales/pt/translation.json';
import sv from './locales/sv/translation.json';
import nl from './locales/nl/translation.json';
import fi from './locales/fi/translation.json';
import pl from './locales/pl/translation.json';
import ro from './locales/ro/translation.json';
import el from './locales/el/translation.json';
import no from './locales/no/translation.json';
import da from './locales/da/translation.json';
import cs from './locales/cs/translation.json';
import sk from './locales/sk/translation.json';
import hr from './locales/hr/translation.json';
import lt from './locales/lt/translation.json';
import et from './locales/et/translation.json';
import lv from './locales/lv/translation.json';
import bg from './locales/bg/translation.json';
import sl from './locales/sl/translation.json';
import sr from './locales/sr/translation.json';
import is from './locales/is/translation.json';
import ar from './locales/ar/translation.json';
import mt from './locales/mt/translation.json';

const resources = {
  fr: { translation: fr },
  en: { translation: en },
  de: { translation: de },
  es: { translation: es },
  it: { translation: it },
  uk: { translation: uk },
  hu: { translation: hu },
  pt: { translation: pt },
  sv: { translation: sv },
  nl: { translation: nl },
  fi: { translation: fi },
  pl: { translation: pl },
  ro: { translation: ro },
  el: { translation: el },
  no: { translation: no },
  da: { translation: da },
  cs: { translation: cs },
  sk: { translation: sk },
  hr: { translation: hr },
  lt: { translation: lt },
  et: { translation: et },
  lv: { translation: lv },
  bg: { translation: bg },
  sl: { translation: sl },
  sr: { translation: sr },
  is: { translation: is },
  ar: { translation: ar },
mt: { translation: mt }
};
const RTL_LANGUAGES = ['ar', 'he', 'fa', 'ur'];
// Initialisation
i18n
  .use(LanguageDetector) // 🧠 Ajoute le détecteur
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr', // Langue par défaut si rien n'est détecté
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'cookie', 'path', 'subdomain'],
      caches: ['localStorage'], // Mémorise la langue détectée dans le localStorage
    }
  });

i18n.on('languageChanged', (lang) => {
  const isRTL = RTL_LANGUAGES.includes(lang);
  document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
  document.documentElement.setAttribute('lang', lang);
});

export default i18n;
